import React, { useState } from "react";
import { BsCalendarMinusFill, BsChevronRight, BsChevronUp } from "react-icons/bs";
import { AiOutlineCheck, AiOutlineWarning, AiOutlineFileText } from "react-icons/ai";

export default function SingleTranscription({
  transcribeStatus,
  refId,
  isClinicalRequired,
  createdDate,
  transcriptionBetween,
  viewTs

}) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={`transactionContent ${isExpanded ? "expanded" : ""}`}>
      <div>
        <p>Status</p>
        <h5>{transcribeStatus}</h5>
      </div>
      <div
        className="borderContent-left"
        style={{
          width: "100%"
        }}
      >
        <p>Reference ID</p>
        <h5>{refId}</h5>
        {/* <p>Sub -3M</p> */}
      </div>
      <div className="borderContent-kit">
        <p>Author</p>
        {isClinicalRequired ? (
          <h5>
            <span>
              <AiOutlineWarning color="red" />
            </span>{" "}
            clinician Required
          </h5>
        ) : (
          <h5>
            <span>
              <AiOutlineCheck color="green" />
            </span>{" "}
            {transcriptionBetween}
          </h5>
        )}
      </div>
      <div>
        <p>Created</p>
        <h5>{createdDate}</h5>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start"
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
          <button className="viewDetailsBtn" onClick={() => {viewTs()}}>
            <span className="chartingColour">View Transcription</span>
            <BsChevronRight
              style={{
                fontSize: "1.5rem",
                color: "#007F61",
                cursor: "pointer"
              }}
            />
          </button>
        </div>
      </div>
    </div>
  );
}
